module.exports = __webpack_public_path__ + "img/icon-mb.1cc5cbe9.png";